module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAQCAYAAADJViUEAAAACXBIWXMAAAsSAAALEgHS3X78AAABR0lEQVQoz2OcP39hwffv3/tFRUUZcIGHDx++vH79Bre4uFh3a2tzE0ychYGBgcHe3o5BS0sTp+YFCxb9MDIy+MHOzlHV0NBk1NBQFwDXTCzw8vJgv3z5in9VVc2F+/cfOBCl+devX9xPnz6/PGnSlFcwMVVVFW2iNAcG+ou8fv3GESkMGF6+fGVKlGZRUVEG9AB9+fIVAxO6wm+NWxi+NW5BEfvev5fhnXwVw+8T91DEMWz+c+050QGI19lfi9cw/FxzjoFJWgCrPBMujX+vPWf4ueYcA2eBMwOTrCBpNv8+DvEfe6gRxDsn7hNvM7O2JCSOd15j+IsjHHDazGqhxMBiocjwrWkrAyMvB3Gauet94Gy+lakMf689Z2CSEWT4c+0ZA4uWFH7NzFqSWPmsFkrYbT548BDDtWvXiY7f169fM3BycjIAAOiwb0jqVqKRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/grid/idd.png
// module id = +B4M
// module chunks = 1